// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';

// ANTD
import Spin from 'antd/lib/spin';

// APOLLO
import { graphql } from 'react-apollo';
import sessionFragment from 'ApolloClient/Fragments/sessionFragment';
import GET_SESSIONS from 'ApolloClient/Queries/sessions';

// COMPONENTS
import SessionsTable from 'components/common/SessionsTable';

export const UserSessionsTable = ({ data, showCols, onEdit }) => {
  const { error, loading, sessions } = data;

  if (error) {
    console.log(error);
    return <span>Something went wrong :(</span>;
  }

  if (loading) {
    return (
      <div
        className="flex justify-center align-middle"
        style={{ width: 900, maxWidth: '100%', margin: 'auto', height: 400 }}
      >
        <Spin />
      </div>
    );
  }

  return <SessionsTable showCols={showCols} sessions={sessions} onEdit={onEdit} />;
};

UserSessionsTable.propTypes = {
  data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    sessions: PropTypes.arrayOf(propType(sessionFragment)),
  }).isRequired,
  showCols: PropTypes.arrayOf(PropTypes.string),
  onEdit: PropTypes.func,
};

UserSessionsTable.defaultProps = {
  showCols: ['title', 'description', 'category', 'date', 'time', 'client', 'edit', 'delete'],
  onEdit: () => {},
};

const withData = graphql(GET_SESSIONS);

export default withData(UserSessionsTable);



// WEBPACK FOOTER //
// ./src/components/common/UserSessionsTable/index.js